import React, { useState } from 'react';
import { Stepper, Step, StepLabel, Button, Box } from '@mui/material';
import StepOne from './Steps/StepOne';
import StepTwo from './Steps/StepTwo';

const steps = ['Upload PDI Sample', 'Next Step'];

const PdiReviewTpi = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [plusTolerance, setPlusTolerance] = useState('');
  const [minusTolerance, setMinusTolerance] = useState('');

  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      setActiveStep(0);
      setTableData([]);
    } else {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => setActiveStep((prev) => prev - 1);

  const handleFileUploadStatus = (status) => {
    setIsFileUploaded(status);
  };

  const handleComplete = (data) => {
    setTableData(data);
    handleNext();
  };

  const handleToleranceChange = (plus, minus) => {
    setPlusTolerance(plus);
    setMinusTolerance(minus);
  };

  return (
    <div className="p-4 bg-white rounded-md">
      <h2 className="text-2xl font-semibold mb-4">PDI REVIEW-TPI</h2>

      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Box sx={{ mt: 4 }}>
        {activeStep === 0 && (
          <StepOne
            onFileUploadStatus={handleFileUploadStatus}
            onComplete={handleComplete}
            onToleranceChange={handleToleranceChange}
          />
        )}
        {activeStep === 1 && <StepTwo tableData={tableData} />}

        <div className="mt-4 flex justify-between">
          <Button
            disabled={activeStep === 0}
            onClick={handleBack}
            sx={{ color: '#424752' }}
          >
            Back
          </Button>
          <Button
            variant="contained"
            onClick={handleNext}
            disabled={activeStep === 0 && (!isFileUploaded || !plusTolerance || !minusTolerance)} // Disable Next if file not uploaded or tolerances not defined
            sx={{
              backgroundColor: '#424752',
              '&:hover': {
                backgroundColor: '#424752',
              },
            }}
          >
            {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
          </Button>
        </div>
      </Box>
    </div>
  );
};

export default PdiReviewTpi;
